import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllApps = () => apiClient.get(`${REST_API_BASE_URL}/apps`);

export const getAllItemsByApp = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/app/${id}/parentItems`);

export const getAllItems = () => apiClient.get(`${REST_API_BASE_URL}/items`);

export const saveApp = (app: any) =>
  apiClient.post(`${REST_API_BASE_URL}/app`, app);

export const getApp = (id) => apiClient.get(`${REST_API_BASE_URL}/app/${id}`);

export const updateApp = (id: number, app: any) =>
  apiClient.put(`${REST_API_BASE_URL}/app/${id}`, app);

export const deleteApp = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/app/${id}`);

//export const getAllAppsByLoggedInUser = () => apiClient.get(`${REST_API_BASE_URL}/apps`);

export const addItemToApp = (appid, itemid) =>
  apiClient.put(`${REST_API_BASE_URL}/app/${appid}/item/${itemid}`);

export const removeItemToApp = (appid, itemid) =>
  apiClient.delete(`${REST_API_BASE_URL}/app/${appid}/item/${itemid}`);

export default apiClient;
